import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { CheckPicker } from 'rsuite';
import { CheckPickerProps } from 'rsuite/lib/CheckPicker';
import { parseSelectedText } from '../../../pages/IPA/Estrategia/pages/RegrasDePreco/lib';
import { FilterSelectAll, FilterSelectAllProps, usePasteValuesMenu } from '../../FilterSection';
import { ChipIcon } from '../ChipIcon';
import { Loading } from '../Loading';
import styles from './CheckPill.module.scss';

type RenderValueProps = React.HtmlHTMLAttributes<HTMLDivElement> & {
  value: any[];
};

const RenderValue = ({ className, children, value, ...props }: RenderValueProps) => {
  return (
    <div className={classNames(styles['render-value'], className)} {...props}>
      <span>{value && children}</span>
      <span className="counter">{value && value?.length}</span>
    </div>
  );
};

export type CheckPillProps = CheckPickerProps & {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  error?: boolean;
  selectedValueText?: string;
  selectAll?: FilterSelectAllProps;
  isLoading?: boolean;
  textLoading?: string;
  search?: string;
  /** Mostra o botão "Colar lista de códigos" no menu, igual ao filtro de produtos do Gerenciador */
  pasteValues?: boolean;
  onConfirmPasteValues?: (query: string) => void;
  modalText?: string;
};

export const CheckPill = ({
  data = [],
  value = [],
  className,
  placeholder = 'Selecione uma opção',
  startIcon,
  endIcon,
  error,
  selectedValueText = parseSelectedText(value.length),
  selectAll,
  isLoading,
  textLoading = 'Carregando...',
  textSearch = 'Pesquisar',
  locale,
  disabled,
  search,
  searchable,
  pasteValues = false,
  modalText,
  renderMenu,
  renderExtraFooter,
  onChange,
  onSearch,
  onConfirmPasteValues,
  ...props
}: CheckPillProps) => {
  const pasteMenu = usePasteValuesMenu({ enabled: pasteValues, search, modalText, onSearch, onConfirm: onConfirmPasteValues });

  const renderDefaultMenu = (menu: ReactNode) => {
    const content = isLoading ? <Loading>{textLoading}</Loading> : menu;
    return pasteMenu.renderMenu(content);
  };

  return (
    <div className={classNames(styles['select-pill'], 'info-filter', error && 'info-filter-error', className)}>
      {startIcon && <ChipIcon className="filter-start-icon">{startIcon}</ChipIcon>}
      <CheckPicker
        data={data}
        placeholder={placeholder}
        value={disabled ? undefined : value}
        onChange={(value, event) => {
          onChange?.(value ?? undefined, event);
        }}
        renderValue={value => <RenderValue value={value}>{selectedValueText || placeholder}</RenderValue>}
        renderMenu={renderMenu || renderDefaultMenu}
        locale={
          locale || {
            noResultsText: isLoading ? textLoading : 'Nenhum item encontrado',
            searchPlaceholder: textSearch,
          }
        }
        renderExtraFooter={
          renderExtraFooter ||
          (selectAll
            ? () => {
                return <FilterSelectAll checked={data?.length === value?.length && !!value?.length} {...selectAll} />;
              }
            : undefined)
        }
        searchable={pasteValues ? false : searchable}
        onSearch={pasteValues ? pasteMenu.handleSearch : onSearch}
        {...props}
      />

      {endIcon && <ChipIcon className="filter-end-icon">{endIcon}</ChipIcon>}

      {pasteMenu.modal}
    </div>
  );
};
